import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["id", "onClick"]
const _hoisted_3 = {
  key: 1,
  class: "task__menu-option pointer-none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _directive_close_popper = _resolveDirective("close-popper")!

  return (_openBlock(), _createBlock(_component_BaseSubHeading, {
    size: "large",
    weight: "400",
    class: "task__menu__moveTo custom-scroll"
  }, {
    default: _withCtx(() => [
      (!_ctx.$wait.is('loadingTaskMoveData'))
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskMoveOptions, (taskMoveOption, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("button", {
                id: taskMoveOption.id,
                key: index,
                class: "task__menu-option",
                onClick: ($event: any) => (_ctx.taskMove(taskMoveOption))
              }, [
                (taskMoveOption.type === 'SPRINT')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["dot", [`is-${taskMoveOption?.sprintStatus.toLowerCase()}`]])
                    }, null, 2))
                  : _createCommentVNode("", true),
                (taskMoveOption.type === 'TEAM')
                  ? (_openBlock(), _createBlock(_component_Avatar, {
                      key: 1,
                      src: taskMoveOption.pictureUrl,
                      size: "sm",
                      type: "teamsGroup",
                      class: "task__menu__moveTo-avatar"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_BaseSubHeading, {
                  size: "medium",
                  weight: "400"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(taskMoveOption.label), 1)
                  ]),
                  _: 2
                }, 1024)
              ], 8, _hoisted_2)), [
                [
                  _directive_close_popper,
                  void 0,
                  void 0,
                  { all: true }
                ]
              ])
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, " Loading... "))
    ]),
    _: 1
  }))
}